<template>
  <div class="page-container" :style="containerStyle">
    <Sidebar v-if="showSidebar" @updateScreenInfo="handleUpdateScreenInfo" @update-is-closed="handleSidebarToggle" />
    <div class="screen-info">
      <div class="screen-name">{{ screenName }}</div>
      <div class="screen-description"></div>
      <v-text-field v-model="screenExplanation" label="画面説明" outlined rows="3"
        @keydown.enter.prevent="saveScreenExplanation"></v-text-field>
    </div>
    <BoardView v-if="boardViewVisible" />
  </div>
</template>

<script>
import BoardView from "./organisms/BoardView.vue";
import Sidebar from "@/components/Sidebar.vue";
import CreateNewApi from "@/api/createNew";
import ScreenApi from "@/api/home";

export default {
  name: "BasicPage",
  components: {
    Sidebar,
    BoardView,
  },
  created() {
    const screenData = JSON.parse(sessionStorage.getItem("screenData"));
    this.screenId = screenData.screenId;
    this.getScreenData(this.screenId);
  },
  data() {
    return {
      isSidebarClosed: false,
      showSidebar: true,
      screenId: null,
      screenName: "",
      screenExplanation: "",
      tableId: null,
      boardViewVisible: true,
    };
  },
  watch: {
    screenName() {
      this.boardViewVisible = false;
      this.$nextTick(() => {
        this.boardViewVisible = true;
      });
    },
  },
  methods: {
    async saveScreenExplanation() {
      try {
        // 画面説明保存処理をここに実装
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const staffName = localStorage.getItem("staffName");
        const screenId = sessionStorage.getItem("tableId");

        await CreateNewApi.screenEdit(
          authUserId,
          sessionKey,
          staffName,
          screenId,
          this.screenExplanation
        );
        this.getScreenData(screenId);
      } catch (error) {
        console.error(error.message);
        [7];
      }
    },

    async getScreenData(screenId) {
      try {
        if (screenId) {
          const authUserId = localStorage.getItem("authUserId");
          const sessionKey = localStorage.getItem("sessionKey");
          const result = await ScreenApi.getScreenData(
            screenId,
            authUserId,
            sessionKey
          );
          if (result.data) {
            this.screenId = result.data.screenId;
            this.screenName = result.data.screenName;
            this.tableId = result.data.tableId;
            this.screenExplanation = result.data.screenExplanation;
          } else {
            console.log("データが存在しません。");
          }
        } else {
          console.error("screenId: ", screenId);
        }
      } catch (error) {
        console.error(error.message);
        [7];
      }
    },
    handleSidebarToggle(isClosed) {
      this.isSidebarClosed = isClosed;
    },
    handleUpdateScreenInfo(screenData) {
      // プロパティの更新
      this.screenId = screenData.screenId;
      this.screenName = screenData.screenName;
      this.screenExplanation = screenData.screenExplanation;
      this.tableId = screenData.tableId;

      // セッションストレージに tableId を格納
      sessionStorage.setItem("tableId", screenData.tableId);
      sessionStorage.setItem("screenName", screenData.screenName);
    },
  },
  computed: {
    containerStyle() {
      return {
        marginLeft: this.isSidebarClosed ? "0" : "15%",
        width: this.isSidebarClosed ? "100%" : "85%",
      };
    },
  },
};
</script>

<style scoped>
.page-container {
  padding: 2vh;
  /* background-color: #f4f9fc; */
  /* border-radius: 8px; */
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
  width: 70%;
  margin: 2vh auto;
}

.screen-info {
  text-align: center;
  background-color: #ffffff;
  padding: 2vh;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 3vh;
  height: auto;
}

.screen-description {
  font-size: 20px;
  color: #333;
  margin: 1vh 0;
  margin-bottom : 1vh;
}

.screen-name {
  font-size: 24px;
  font-weight: bold;
  display: flex;
}

.screen-description {
  color: #666;
}

.board-container {
  width: 85%;
  height: 60vh;
  margin: 2vh auto;
  border: 1vh solid #4a90e2;
  background-color: #ffffff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.board-view h2,
.no-board-view h2 {
  font-size: 22px;
  color: black;
  text-align: center;
  margin-top: 2vh;
}
</style>
